import * as React from 'react';
import * as style from '../MainPage.css';
import { StepsTileContainer } from '../../StepsTile';
import { Questions } from '../../Questions';
import { IMainPageContent } from '../../../types/helper';
import { PictureVasyaMobile } from '../picture/vasya-mobile';
import { clickAskProfessional } from '../../../utils/events';

interface IMainViewMobile {
    content: IMainPageContent;
}

export const ViewMobile = (props: IMainViewMobile) => {
    // tslint:disable:max-line-length
    return (
    <React.Fragment>
      <div className={style['body']}>
        <div className={style['title']}>
          {props.content && props.content.title}
        </div>
        <div className={style['description']}>
          {props.content && props.content.body}
        </div>
        <div className={style['picture']}>
          <PictureVasyaMobile />
        </div>
      </div>
      <div className={style['container']}>
        <StepsTileContainer />
        <Questions />
        <div className={style['footer_container']}>
          <div className={style['footer_title']}>Не нашли нужной вам информации?</div>
          <div>
            <a onClick={clickAskProfessional} href="https://www.cian.ru/add-vopros/">
              Спросите у профессионала
            </a>
            <br />
            или <a href="https://docs.google.com/forms/u/1/d/e/1FAIpQLSchgoXzaxnvx5obzuLB9cyucYPhha1KKvGsky-aX-TmZybndQ/viewform">оставьте отзыв о Помощнике</a>
          </div>
        </div>
      </div>
    </React.Fragment>
    );
  };
